import _page from "./src/page";
import _landing from "./src/landing";

export const Landing = _landing;
export const Page = _page;

export default _page;